import 'angular:locale/data:nl';
import 'angular:locale/data:da';
import 'angular:locale/data:de';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
